import { focusTopics } from '@/mocks/homeData';

const topicImages = [
  'https://readdy.ai/api/search-image?query=Blurred%20luxury%20hotel%20hallway%20at%20night%20with%20dramatic%20spotlight%20shadows%20and%20mysterious%20atmosphere%2C%20paparazzi%20hidden%20camera%20aesthetic%2C%20warm%20amber%20light%20against%20dark%20corridor%2C%20cinematic%20thriller%20mood%2C%20entertainment%20scandal%20photography%20style%20with%20high%20tension&width=500&height=350&seq=focus-topic-1&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20TV%20show%20production%20set%20with%20dramatic%20lighting%20contrast%2C%20empty%20director%20chair%20under%20spotlight%2C%20backstage%20drama%20atmosphere%2C%20broadcast%20studio%20equipment%20in%20shadows%2C%20cinematic%20documentary%20composition%2C%20dark%20moody%20entertainment%20industry%20insider%20aesthetic&width=500&height=350&seq=focus-topic-2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Luxury%20corporate%20office%20with%20scattered%20documents%20under%20dramatic%20desk%20lamp%20lighting%2C%20tax%20investigation%20thriller%20atmosphere%2C%20warm%20light%20pool%20against%20dark%20room%2C%20cinematic%20noir%20style%20with%20deep%20shadows%2C%20financial%20drama%20mood%2C%20high%20contrast%20professional%20photography&width=500&height=350&seq=focus-topic-3&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Empty%20cinema%20theater%20with%20single%20dramatic%20spotlight%20beam%20on%20silver%20screen%2C%20controversial%20film%20premiere%20atmosphere%2C%20rich%20crimson%20curtain%20shadows%2C%20cinematic%20wide%20composition%2C%20artistic%20tension%20and%20mystery%20mood%2C%20dark%20theatrical%20aesthetic%20with%20warm%20accent&width=500&height=350&seq=focus-topic-4&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Elegant%20luxury%20mansion%20exterior%20at%20dramatic%20twilight%20hour%20with%20storm%20clouds%20gathering%2C%20golden%20hour%20warm%20light%20piercing%20through%20darkness%2C%20high%20society%20intrigue%20atmosphere%2C%20cinematic%20establishing%20shot%2C%20wealthy%20lifestyle%20drama%20aesthetic%2C%20moody%20architectural%20photography&width=500&height=350&seq=focus-topic-5&orientation=landscape',
];

export default function FocusTopicsSection() {
  return (
    <section id="carousel" className="py-14 md:py-18 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-600 bg-accent-50 rounded-full mb-4">
            热门关注
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">当前最受关注的娱乐圈热点事件</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {focusTopics.map((topic, idx) => (
            <article
              key={topic.id}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={topicImages[idx]}
                  alt={topic.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={idx > 2 ? 'lazy' : undefined}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                {topic.hot && (
                  <span className="absolute top-3 left-3 px-2 py-0.5 bg-primary-500 text-white text-xs font-bold rounded-md">
                    HOT
                  </span>
                )}
                <span className="absolute bottom-3 left-3 px-2 py-0.5 bg-black/50 backdrop-blur-sm text-white/90 text-xs rounded-md">
                  {topic.category}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {topic.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-2 line-clamp-2 leading-relaxed">
                  {topic.summary}
                </p>
                <div className="flex items-center justify-between mt-3 pt-3 border-t border-background-200/70">
                  <span className="text-xs text-foreground-400">{topic.time}</span>
                  <span className="text-xs text-primary-500 font-medium whitespace-nowrap cursor-pointer">
                    阅读全文 →
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}